<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    enable-background="new 0 0 21 21"
    xml:space="preserve"
  >
    <g id="icon">
      <line
        x1="2.5"
        y1="16.5"
        x2="4.5"
        y2="16.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="2.5"
        y1="12.5"
        x2="4.5"
        y2="12.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="2.5"
        y1="14.5"
        x2="4.5"
        y2="14.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="2.5"
        y1="10.5"
        x2="4.5"
        y2="10.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="2.5"
        y1="8.5"
        x2="4.5"
        y2="8.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="2.5"
        y1="6.5"
        x2="4.5"
        y2="6.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="2.5"
        y1="4.5"
        x2="4.5"
        y2="4.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M3.5,17.9v0.8c0,0.4418,0.3582,0.8,0.8,0.8h13.4c0.4418,0,0.8,-0.3582,0.8,-0.8V2.3c0,-0.4418,-0.3582,-0.8,-0.8,-0.8H4.3c-0.4418,0,-0.8,0.3582,-0.8,0.8v0.7"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="8"
        y1="4.5"
        x2="15"
        y2="4.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="8"
        y1="8.5"
        x2="15"
        y2="8.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="7"
        y1="6.5"
        x2="16"
        y2="6.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <polyline
        points="13.1,11.5 15.4974,11.5083 11.5424,15.3553 9.5706,13.8022 7.0527,15.9301"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <line
        x1="14.954"
        y1="13.8104"
        x2="15.4974"
        y2="11.5296"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
